import { IGetRegionSettlementsDTO } from '@/models/regions.model';

class GetRegionSettlementsDTO implements IGetRegionSettlementsDTO {
  region_id: string;
  page: number;
  limit?: number;

  constructor({ region_id, page }: { region_id: string; page: number }) {
    this.region_id = region_id;
    this.page = page ?? 1;
    this.limit = 10;
  }
}

export default GetRegionSettlementsDTO;
